export const vehicleLookUpService = {
    searchCars,
    searchMainGroups,
    searchSchemes,
    carProperties
};

async function carProperties() {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/vehicle-lookup/car-properties`, requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function searchCars(
    vin,
    carTypeId,
    model,
    year,
    engine
) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    let query = {};

    if (vin) {
        query.vin = vin;
    }
    if (carTypeId) {
        query.car_type_id = carTypeId;
    }
    if (model) {
        query.model = model;
    }
    if (year) {
        query.year = year;
    }
    if (engine) {
        query.engine = engine;
    }

    return await fetch(`${process.env.VUE_APP_API_URL}/api/vehicle-lookup/car-search?` + new URLSearchParams(query), requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function searchMainGroups(carTypeId) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/vehicle-lookup/main-group-search?` + new URLSearchParams({
        car_type_id: carTypeId
    }), requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function searchSchemes(
    mainGroupId,
    functionalGroupId,
    carTypeId
) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/vehicle-lookup/scheme-search?` + new URLSearchParams({
        main_group_id: mainGroupId,
        functional_group_id: functionalGroupId,
        car_type_id: carTypeId
    }), requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}